export const teplo_t7 = {
    name: 'Графики температуры на выходе котла ЕК1',
    valuetitle: '°C',
    ps: {
        ti_8_96_7: {caption: 'Т7 - температура на выходе котла EK1'},
        ti_8_96_16: {caption: 'Т7-Т6 - дельта температур котла ЕК1'},
    },
};
export const teplo_t8 = {
    name: 'Графики температуры на выходе котла ЕК1',
    valuetitle: '°C',
    ps: {
        ti_8_96_8: {caption: 'Т8 - температура на выходе котла EK2'},
        ti_8_96_17: {caption: 'Т8-Т6 - дельта температур котла ЕК2'},
    },
};
export const teplo_t10 = {
    name: 'Графики температур контура нагрузки',
    valuetitle: '°C',
    ps: {
        ti_8_96_10: {caption: 'Т10 - температура н авыходе ТО нагрузки'},
        ti_8_96_9: {caption: 'Т9 - температура обратки с нагрузки'},
    },
};
export const teplo_t1 = {
    name: 'График температуры в баке аккумуляторе',
    valuetitle: '°C',
    ps: {
        ti_8_96_1: {caption: 'Т1 - темепература в баке аккумуляторе'},
        ti_8_96_21: {caption: 'Тзд1 - задание температуры ограничения разряда'},
    },
};
export const teplo_t11 = {
    name: 'Графики температуры контура генерации ТО',
    valuetitle: '°C',
    ps: {
        ti_8_96_11: {caption: 'Т11 - температура на выходе ТО генерации'},
        ti_8_96_6: {caption: 'Т6 - температура на входе котлов ЕК1, ЕК2'},
    },
};
export const teplo_t2 = {
    name: 'Графики температур на нагрузку',
    valuetitle: '°C',
    ps: {
        ti_8_96_2: {caption: 'Т2- температура подачи в нагрузку'},
        ti_8_96_23: {caption: 'Тзд3 - Задание температуры подачи в нагрузку'},
    },
};
export const teplo_t12 = {
    name: 'Графики температуры на нагрузку',
    valuetitle: '°C',
    ps: {
        ti_8_94_7: {caption: 'ТЕ1а - температура в подающем трубопроводе'},
        ti_8_94_8: {caption: 'Т9 - температура обратки с нагрузки'},
    },
};
export const teplo_t3 = {
    name: 'Графики температуры наружного воздуха',
    valuetitle: '°C',
    ps: {
        ti_8_96_3: {caption: 'Т3 - температура наружного воздуха'},
        ti_8_96_66: {caption: 'Средняя температура наружного воздуха за сутки'},
    },
};
export const teplo_t4 = {
    name: 'График температуры воздуха в контрольном помещении',
    valuetitle: '°C',
    ps: {
        ti_8_96_4: {caption: 'Т4 - температура в контрольном помещении'},
        ti_8_96_22: {caption: 'Тзд2 - уставка температуры в контрольном помещении'},
    }
};
export const teplo_t5 = {
    name: 'График температуры воздуха в узле ВЕНА',
    valuetitle: '°C',
    ps: {
        ti_8_96_5: {caption: 'Т5 - температура в узле ВЕНА'},
    },
};
export const gidro_t2 = {
    name: 'График расхода теплоносителя через ТО',
    valuetitle: 'м\xB3/ч',
    ps: {
        ti_8_98_3: {caption: 'Qг - расход через теплообменник'},
    },
};
export const gidro_t1 = {
    name: 'График расхода сетевой воды',
    valuetitle: 'м\xB3/ч',
    ps: {
        ti_8_94_25: {caption: 'Qн – расход сетевой воды через нагрузку'},
    },
};
export const electro_t1 = {
    name: 'График напряжений ввода №1',
    valuetitle: 'В',
    ps: {
        ti_8_92_141: {caption: 'Напряжение фазы А'},
        ti_8_92_142: {caption: 'Напряжение фазы B'},
        ti_8_92_143: {caption: 'Напряжение фазы C'},
    },
};
export const electro_t2 = {
    name: 'График токов ввода №1',
    valuetitle: 'А',
    ps: {
        ti_8_92_151: {caption: 'Ток потребления фазы А'},
        ti_8_92_152: {caption: 'Ток потребления фазы B'},
        ti_8_92_153: {caption: 'Ток потребления фазы C'},
    },
};
export const electro_t3 = {
    name: 'График напряжений ввода №2',
    valuetitle: 'В',
    ps: {
        ti_8_93_141: {caption: 'Напряжение фазы А'},
        ti_8_93_142: {caption: 'Напряжение фазы B'},
        ti_8_93_143: {caption: 'Напряжение фазы C'},
    },
};
export const electro_t4 = {
    name: 'График токов ввода №2',
    valuetitle: 'А',
    ps: {
        ti_8_93_151: {caption: 'Ток потребления фазы А'},
        ti_8_93_152: {caption: 'Ток потребления фазы B'},
        ti_8_93_153: {caption: 'Ток потребления фазы C'},
    },
};



// WEBPACK FOOTER //
// ./src/trends.js